module.exports = "<!-- <span>HtmlViewerComponent</span> -->\r\n<div [innerHTML]=\"data | sanitizeHtml:'html'\"></div>\r\n"